// extracted by mini-css-extract-plugin
export default {"container":"AuthContainer_container__lV0tY","box":"AuthContainer_box__pnJdT","title":"AuthContainer_title__nESBz","subtitle":"AuthContainer_subtitle__Xz1u7"};